import React, { useMemo } from 'react';
import { Text } from '@atlaskit/primitives';
import { useLocale } from '@atlassian/jira-tenant-context-controller/src/components/locale/index.tsx';
import { formatDistanceWithLocale } from '@atlassian/jira-platform-utils-date-fns/src/main.tsx';

type RelativeTimeProps = {
	time: string | number;
};
export const RelativeTime = ({ time }: RelativeTimeProps) => {
	const locale = useLocale();

	const timeDisplayString = useMemo(
		() => formatDistanceWithLocale(new Date(time), new Date(), locale, true),
		[time, locale],
	);

	return (
		<Text color="color.text.subtle" as="p">
			{timeDisplayString}
		</Text>
	);
};
